import * as React from 'react'
import { cn } from '@/lib/utils'

const alertVariants = {
  destructive: 'border-destructive/30 bg-destructive/10 text-destructive',
  warning: 'border-warning/30 bg-warning/10 text-foreground',
  success: 'border-success/30 bg-success/10 text-success',
}

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof alertVariants
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant = 'destructive', ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn('rounded-md border px-3 py-2 text-body-sm', alertVariants[variant], className)}
      {...props}
    />
  ),
)
Alert.displayName = 'Alert'
